import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { AdminBoxSaleGroupCosmeticResponse } from './admin-box-sale-group-cosmetic.response';

@jsonObject
export class AdminBoxSaleVariantResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonArrayMember(AdminBoxSaleGroupCosmeticResponse)
  public readonly cosmetics!: AdminBoxSaleGroupCosmeticResponse[];
}
